import { Component } from "@angular/core";

@Component({
    selector: 'go-to-brightside-desktop',
    templateUrl: './go-to-brightside-desktop.component.html',
    styleUrls: ['./go-to-brightside-desktop.component.scss'],
    standalone: false
})
  export class GoToBrightsideDesktopComponent {
  }